"use client";

import { MotionValue } from "motion/react";
import * as motion from "motion/react-client";

export function ProgressCircle({
  progress,
  size,
  strokeWidth = 10,
  color = "var(--yz-foreground)",
  bgColor = "rgba(255,255,255,0)"
}: {
  progress: MotionValue<number>;
  size?: number;
  strokeWidth?: number;
  color?: string | MotionValue<string>;
  bgColor?: string;
}) {
  const circle: React.CSSProperties = {
    strokeWidth,
    strokeDashoffset: 0,
    strokeLinecap: "round",
    fill: "none"
  };
  // 基于 viewBox 计算
  const r = Math.max(1, Math.floor(50 - strokeWidth / 2));

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid meet"
      style={{
        width: size ?? "100%",
        height: size ?? "100%",
        overflow: "visible"
      }}>
      <g transform="rotate(-90 50 50)">
        <circle
          cx="50"
          cy="50"
          r={r}
          pathLength="1"
          style={{ ...circle, stroke: bgColor }}
        />
        <motion.circle
          cx="50"
          cy="50"
          r={r}
          pathLength="0"
          style={{ ...circle, stroke: color, pathLength: progress }}
        />
      </g>
    </svg>
  );
}
